import styled from 'styled-components';
import { primaryColors } from 'common/styles/theme';

export const Item = styled.div`
  background-color: ${(props) => props.color};
  padding: 20px;
  margin: 10px 0 0 0;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  img {
    margin: 0 12px 0 0;
    width: 19px;
  }
`;

export const Title = styled.span`
  color: ${primaryColors.black};
`;

export const Dedline = styled.p`
  color: ${primaryColors.grey};
  font-size: 13px;
  margin: 5px 0 0 32px;
`;
